import script from "./BookLesson.vue?vue&type=script&setup=true&lang=js"
export * from "./BookLesson.vue?vue&type=script&setup=true&lang=js"

import "./BookLesson.vue?vue&type=style&index=0&id=25959652&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25959652"]])

export default __exports__